import { __makeTemplateObject, __assign } from 'tslib';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { typography, space, layout, positioning } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var defaultStyles = {
  color: "darkMofo",
  fontFamily: "normal",
  fontSize: [1, 2],
  px: [12, 15],
  height: [40, 44],
  extra: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNy4yIDYuNmExIDEgMCAwMS0uNjItLjIxTC44IDEuNzYgMi4wNS4yIDcuMiA0LjMzIDEyLjM2LjJsMS4yNSAxLjU2TDcuODMgNi40YTEgMSAwIDAxLS42My4yeiIgZmlsbD0iIzgyODQ4OCIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=\");\n    background-repeat: no-repeat;\n    background-position: right 20px top 50%;\n    background-size: 14px;\n    background-color: ", ";\n    user-select: none;\n    cursor: pointer;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    appearance: none;\n    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n      color 0.3s ease-in-out;\n\n    &::placeholder {\n      opacity: 0.5;\n      font-family: inherit;\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "], ["\n    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNy4yIDYuNmExIDEgMCAwMS0uNjItLjIxTC44IDEuNzYgMi4wNS4yIDcuMiA0LjMzIDEyLjM2LjJsMS4yNSAxLjU2TDcuODMgNi40YTEgMSAwIDAxLS42My4yeiIgZmlsbD0iIzgyODQ4OCIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=\");\n    background-repeat: no-repeat;\n    background-position: right 20px top 50%;\n    background-size: 14px;\n    background-color: ", ";\n    user-select: none;\n    cursor: pointer;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-color: ", ";\n    border-radius: 5px;\n    width: 100%;\n    appearance: none;\n    transition: background-color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n      color 0.3s ease-in-out;\n\n    &::placeholder {\n      opacity: 0.5;\n      font-family: inherit;\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: 0 0 0 1px ", ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      color: ", ";\n      background-color: ", ";\n      border-color: ", ";\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fieldBorder;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkMofo;
  }, function (_a) {
    var theme = _a.theme,
      hoverColor = _a.hoverColor;
    return hoverColor && theme.colors[hoverColor] || hoverColor || "#a3a7af";
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.brand;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.dorianGray;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.almostWhite;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fieldBorder;
  })
};
var StyledSelect = /*#__PURE__*/styled("select").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Select__StyledSelect",
  componentId: "sc-18qlf2q-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), flexboxes, typography, space, layout, positioning, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var Select = function (props) {
  return React__default.createElement(StyledSelect, __assign({}, defaultStyles, props));
};
var templateObject_1, templateObject_2;

export { Select, StyledSelect };
//# sourceMappingURL=Select.js.map
